<template>
  <v-container class="tool-detail-container">
    <v-row class="mt-5 justify-center">
      <v-col cols="12" md="6" class="mb-4 d-flex justify-start">
        <v-btn @click="goBack" color="primary" class="back-button" small>
          返回
        </v-btn>
      </v-col>
      <v-col cols="12" md="6" class="mb-4 d-flex justify-center">
        <v-card elevation="8" class="tool-icon-card">
          <v-img :src="tool.icon" alt="Tool Icon" height="150" width="150" contain></v-img>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" class="mb-4">
        <v-card elevation="5" class="tool-info-card">
          <v-card-title class="text-h4 font-weight-bold">{{ tool.name }}</v-card-title>
          <v-divider class="my-2"></v-divider>
          <v-card-subtitle class="text-subtitle-1 mb-3">分类: {{ tool.category }}</v-card-subtitle>
          <v-btn color="secondary" @click="visitWebsite" class="mb-3">进入官网</v-btn>
          <v-card-text>
            <v-divider class="my-2"></v-divider>
            <h3 class="text-h5 font-weight-medium mb-2">工具简介</h3>
            <p class="text-body-1 mb-4">{{ tool.description }}</p>
            <v-divider class="my-2"></v-divider>
            <h3 class="text-h5 font-weight-medium mb-2">使用方法</h3>
            <p class="text-body-1">{{ tool.usage }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      tool: {},
      baseUrl: 'https://mengzi.chat/api/ai/tools',
    };
  },
  mounted() {
    const toolId = this.$route.params.id;
    if (toolId) {
      this.fetchToolDetails(toolId);
    }
  },
  methods: {
    async fetchToolDetails(toolId) {
      try {
        const response = await axios.get(`${this.baseUrl}/tool/${toolId}`);
        if (response.status === 200) {
          this.tool = response.data;
        } else {
          console.error('Failed to fetch tool details:', response);
        }
      } catch (error) {
        console.error('Error fetching tool details:', error);
      }
    },
    visitWebsite() {
      if (this.tool.url) {
        window.open(this.tool.url, '_blank');
      } else {
        alert('官网链接不可用');
      }
    },
    goBack() {
      this.$router.push({ name: 'HomePage' });
    },
  },
};
</script>

<style scoped>
.tool-detail-container {
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.back-button {
  font-size: 10px;
  padding: 5px 8px;
}

.tool-icon-card {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  width: 150px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tool-info-card {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  padding: 20px;
  width: 100%;
}

.v-divider {
  background-color: #e0e0e0;
}

@media (max-width: 768px) {
  .tool-detail-container {
    padding: 15px;
    max-width: 100%;
  }

  .tool-icon-card {
    margin-bottom: 15px;
    align-self: center;
  }

  .tool-info-card {
    padding: 15px;
  }

  .v-btn {
    font-size: 14px;
  }
}
</style>
